function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: ",
        ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:disabled {\n        pointer-events: none;\n        opacity: 0.7;\n    }\n\n    svg {\n        height: ",
        ";\n        width: ",
        ";\n        color: ",
        ";\n        transition: color 50ms ease;\n    }\n\n    @media (hover: hover) {\n        &:hover {\n            svg {\n                color: ",
        ";\n            }\n        }\n    }\n\n    @media (hover: none) {\n        svg {\n            color: ",
        ";\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    height: ",
        ";\n    width: ",
        ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    right: ",
        ";\n    top: 50%;\n    transform: translateY(-50%);\n    pointer-events: none;\n\n    svg {\n        height: 100%;\n        width: 100%;\n        color: ",
        ";\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: block;\n    font-size: ",
        ";\n    ",
        "\n    color: ",
        ";\n    margin-bottom: ",
        ";\n    transition: background-color 100ms ease;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                    height: ",
        ";\n                    padding: 0 ",
        ";\n                "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n                    height: ",
        ";\n                    padding: 0 ",
        ";\n                "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n                    height: ",
        ";\n                    padding: 0 ",
        ";\n                "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n            padding-right: ",
        ";\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n            padding-right: ",
        ";\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n            box-shadow: inset 0 0 0 ",
        " ",
        ";\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n            border-bottom-left-radius: 0;\n            border-bottom-right-radius: 0;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n            border-top-left-radius: 0;\n            border-top-right-radius: 0;\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n                        font-size: ",
        ";\n\n                        &::placeholder {\n                            font-size: ",
        ";\n                        }\n                    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n                        font-size: ",
        ";\n\n                        &::placeholder {\n                            font-size: ",
        ";\n                        }\n                    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n                        font-size: ",
        ";\n\n                        &::placeholder {\n                            font-size: ",
        ";\n                        }\n                    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    line-height: ",
        ";\n    box-sizing: border-box;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    color: ",
        ";\n    font-size: ",
        ";\n    transition: box-shadow 100ms ease, color 100ms ease, opacity 100ms ease,\n        background-color 100ms ease;\n    width: 100%;\n    -webkit-appearance: none;\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    &::placeholder {\n        color: ",
        ";\n        font-size: ",
        ";\n    }\n\n    &:focus,\n    &.focus-visible {\n        outline: none;\n        background-color: ",
        ";\n        box-shadow: inset 0 0 0 ",
        "\n            ",
        ";\n    }\n\n    &:disabled {\n        opacity: 0.7;\n    }\n\n    ",
        "\n\n    ",
        "\n\n    @media screen and (min-width: ",
        ") {\n        ",
        "\n    }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    width: 100%;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    z-index: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useRef, useState } from "react";
import styled, { css } from "styled-components";
import { rem } from "polished";
import HidePasswordIcon from "../../svg/eye-hidden.svg";
import ShowPasswordIcon from "../../svg/eye-visible.svg";
var TextInput = function(props, ref) {
    var className = props.className, _hasError = props.hasError, hasError = _hasError === void 0 ? false : _hasError, label = props.label, _placeholder = props.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, id = props.id, group = props.group, _mousetrap = props.mousetrap, mousetrap = _mousetrap === void 0 ? true : _mousetrap, icon = props.icon, disabled = props.disabled, _inputSize = props.inputSize, inputSize = _inputSize === void 0 ? "md" : _inputSize, type = props.type, onTogglePasswordVisibility = props.onTogglePasswordVisibility, rest = _objectWithoutProperties(props, [
        "className",
        "hasError",
        "label",
        "placeholder",
        "id",
        "group",
        "mousetrap",
        "icon",
        "disabled",
        "inputSize",
        "type",
        "onTogglePasswordVisibility"
    ]);
    var container = useRef(null);
    var _$ref2 = useState(false), focused = _$ref2[0], setFocused = _$ref2[1];
    var _$ref1 = useState(false), showPassword = _$ref1[0], setShowPassword = _$ref1[1];
    return /*#__PURE__*/ _jsxs(ContainerStyled, {
        className: className,
        hasError: hasError,
        focused: focused,
        children: [
            !group && label && /*#__PURE__*/ _jsx(LabelStyled, {
                inputSize: inputSize,
                hasError: hasError,
                htmlFor: id,
                children: hasError ? "".concat(label.trim(), " (required)") : label
            }),
            /*#__PURE__*/ _jsxs(TextInputContainerStyled, {
                ref: container,
                children: [
                    /*#__PURE__*/ _jsx(TextInputStyled, _objectSpread({
                        ref: ref,
                        className: mousetrap ? "mousetrap" : undefined,
                        id: id,
                        hasError: hasError,
                        placeholder: placeholder,
                        autoComplete: "off",
                        autoCorrect: "off",
                        autoCapitalize: "off",
                        spellCheck: "false",
                        group: group,
                        icon: !!icon,
                        disabled: disabled,
                        onFocus: function() {
                            setFocused(true);
                        },
                        onBlur: function() {
                            setFocused(false);
                        },
                        inputSize: inputSize,
                        type: showPassword ? "text" : type,
                        showPasswordToggle: type === "password"
                    }, rest)),
                    icon && /*#__PURE__*/ _jsx(IconContainerStyled, {
                        $disabled: disabled,
                        children: icon
                    }),
                    type === "password" && /*#__PURE__*/ _jsx(ToggleStyled, {
                        type: "button",
                        disabled: disabled,
                        onClick: function() {
                            var _$ref;
                            if (onTogglePasswordVisibility) {
                                onTogglePasswordVisibility(!showPassword);
                            }
                            setShowPassword(!showPassword);
                            (_$ref = container.current.querySelector("input")) === null || _$ref === void 0 ? void 0 : _$ref.focus();
                        },
                        children: showPassword ? /*#__PURE__*/ _jsx(HidePasswordIcon, {}) : /*#__PURE__*/ _jsx(ShowPasswordIcon, {})
                    })
                ]
            })
        ]
    });
};
var ToggleStyled = styled.button.withConfig({
    componentId: "sc-95738cf1-0"
})(_templateObject(), rem(40), rem(20), rem(20), function(param) {
    var theme = param.theme;
    return theme.palette.LightGrey1;
}, function(param) {
    var theme = param.theme;
    return theme.palette.White;
}, function(param) {
    var theme = param.theme;
    return theme.palette.White;
});
var IconContainerStyled = styled.div.withConfig({
    componentId: "sc-95738cf1-1"
})(_templateObject1(), rem(16), rem(16), rem(10), function(param) {
    var $disabled = param.$disabled, theme = param.theme;
    return $disabled ? theme.palette.LightGrey1 : theme.palette.White;
});
var LabelStyled = styled.label.withConfig({
    componentId: "sc-95738cf1-2"
})(_templateObject2(), function(param) {
    var size = param.inputSize;
    return rem(size === "lg" ? 16 : 13);
}, function(param) {
    var theme = param.theme, size = param.inputSize;
    return size === "sm" ? theme.typography.FontNormal : theme.typography.FontMedium;
}, function(param) {
    var theme = param.theme, hasError = param.hasError;
    return hasError ? theme.palette.Red : theme.palette.LightGrey1;
}, rem(8));
var TextInputStyled = styled.input.withConfig({
    componentId: "sc-95738cf1-3"
})(_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.palette.DarkGrey3;
}, rem(8), rem(32), function(param) {
    var theme = param.theme;
    return theme.palette.White;
}, rem(16), function(param) {
    var size = param.inputSize;
    switch(size){
        case "sm":
            return css(_templateObject3(), rem(32), rem(12));
        case "lg":
            return css(_templateObject4(), rem(64), rem(20));
        default:
            return css(_templateObject5(), rem(40), rem(12));
    }
}, function(param) {
    var showPasswordToggle = param.showPasswordToggle;
    return showPasswordToggle && css(_templateObject6(), rem(40));
}, function(param) {
    var icon = param.icon;
    return icon && css(_templateObject7(), rem(40));
}, function(param) {
    var hasError = param.hasError, theme = param.theme;
    return hasError && css(_templateObject8(), rem(1), theme.palette.Red);
}, function(param) {
    var theme = param.theme, hasError = param.hasError;
    return hasError ? theme.palette.Red : theme.palette.LightGrey1;
}, rem(16), function(param) {
    var theme = param.theme;
    return theme.palette.Black;
}, rem(1), function(param) {
    var theme = param.theme, hasError = param.hasError;
    return hasError ? theme.palette.Red : theme.palette.White;
}, function(param) {
    var group = param.group;
    return group === "top" && css(_templateObject9());
}, function(param) {
    var group = param.group;
    return group === "bottom" && css(_templateObject10());
}, function(param) {
    var theme = param.theme;
    return rem(theme.breakpoints.Small);
}, function(param) {
    var size = param.inputSize;
    switch(size){
        case "sm":
            return css(_templateObject11(), rem(13), rem(13));
        case "lg":
            return css(_templateObject12(), rem(16), rem(16));
        default:
            return css(_templateObject13(), rem(14), rem(14));
    }
});
var TextInputContainerStyled = styled.div.withConfig({
    componentId: "sc-95738cf1-4"
})(_templateObject15());
var ContainerStyled = styled.div.withConfig({
    componentId: "sc-95738cf1-5"
})(_templateObject16(), function(param) {
    var focused = param.focused, hasError = param.hasError;
    return focused || hasError ? 2 : 1;
});
export default /*#__PURE__*/ forwardRef(TextInput);
